import React from 'react';
import ReactDOM from 'react-dom';

import SsoFailPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createSsoFailScreen = ({ userId, message, loginLink }) => {
  const domId = 'ssoFailPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <AuthScreenLayout>
        <SsoFailPanel loginLink={loginLink} userId={userId} message={message} />
      </AuthScreenLayout>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createSsoFailScreen = createSsoFailScreen;
